export const checkWafResponse = async (url: string): Promise<number> => {
  try {
    const response = await fetch(url, { method: "HEAD" });
    return response.status;
  } catch (error) {
    console.error("Error:", error);
    return 500;
  }
};
